import { render, staticRenderFns } from "./ProjectPotatoFieldFormGroup.vue?vue&type=template&id=3cec4b44"
import script from "./ProjectPotatoFieldFormGroup.vue?vue&type=script&lang=js"
export * from "./ProjectPotatoFieldFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports